import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  position: relative;
  width: 150px;
`;
